import React from 'react';

import { Link } from "gatsby"

import logo from "../images/logo.svg"
import delimeter from "../images/delimeter.svg"

import Search from "./search"
import NavbarMenu from "./NavbarMenu"

import {
    container,
    header,
    logo as logoStyle,
    left,
    right,
    delimeter as delimeterStyle,
    headerText,
    searchContainer,
    link,
    linkButton,
    menuContainer,
    externalLinks
} from "./Navbar.module.css"

const Navbar = () => {
  return (
    <div className={container}>
        <div className={header}>
            <div className={left}>
                <Link to='/'>
                    <img className={logoStyle} src={logo} alt="Qencode" />
                </Link>  
                <img className={delimeterStyle} src={delimeter} alt='' />
                <div className={headerText}>DEVELOPERS</div>
                {/* <div className={searchContainer}>
                    <Search  />   
                </div> */}
            </div>          
            <div className={right}>
                <div className={searchContainer}>
                    <Search  />   
                </div>
                <div className={externalLinks}>
                    <a className={link} href='https://cloud.qencode.com/' target='_blank' rel="noreferrer">Try Qencode</a>
                    <a className={linkButton} href='https://portal.qencode.com/login' target='_blank' rel="noreferrer">Sign In</a>
                </div>
            </div> 
        </div>
        <div className={menuContainer}>
            <NavbarMenu />
        </div>
    </div>
  );
};

export default Navbar;
